import { render } from "./CoBrandStudio.vue?vue&type=template&id=07f611e7&scoped=true"
import script from "./CoBrandStudio.vue?vue&type=script&lang=js"
export * from "./CoBrandStudio.vue?vue&type=script&lang=js"

import "./CoBrandStudio.vue?vue&type=style&index=0&id=07f611e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f611e7"]])

export default __exports__